import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
export const runMiddlewares = (middlewareFunctions, apiCall, errorCallback) => originalParams => {
  const stack = _Array$from(middlewareFunctions);
  const resources = [];
  const runNext = () => {
    try {
      const nextMiddleware = stack.shift();
      if (nextMiddleware) {
        const result = nextMiddleware(originalParams);
        resources.push(result);
        runNext();
      }
    } catch (err) {
      resources.push(err);
      runNext();
    }
  };
  runNext();
  const error = _findInstanceProperty(resources).call(resources, val => val instanceof Error);
  if (error) {
    return _Promise.reject(errorCallback(error, originalParams, resources));
  }
  return apiCall({
    resources,
    params: originalParams
  }).catch(error => errorCallback(error, originalParams, resources));
};
export const apiWrapper = (apiCall, middlewareFunctions, errorCallback) => (...params) => {
  if (middlewareFunctions && middlewareFunctions.length) {
    return runMiddlewares(middlewareFunctions, apiCall, errorCallback)(params);
  }
  return apiCall({
    params
  }).catch(error => errorCallback(error, params));
};